import { useState } from 'react';

import { getFormSummaryRequest } from '@vyce/core/src/api/forms';
import { FormSummary as FormSummaryType } from '@vyce/core/src/types';

export const useFormAnswers = ({ userId, companyId }: { userId: string; companyId: string }) => {
  const [formSummary, setFormSummary] = useState<FormSummaryType | null>(null);
  const [loading, setLoading] = useState(false);

  const getFormSummary = async (formId: string) => {
    if (!companyId || !userId) {
      return;
    }
    try {
      setLoading(true);
      const response = await getFormSummaryRequest({
        companyId,
        formId,
        userId,
      });
      setFormSummary(response.summary);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    formSummary,
    loading,
    getFormSummary,
    setFormSummary,
  };
};
